import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\"],\"subsets\":[\"latin\"],\"variable\":\"--font-poppins\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"700\"],\"subsets\":[\"latin\"],\"variable\":\"--font-roboto\",\"display\":\"swap\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/public/svg/IconLogo.svg");
;
import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/public/svg/IconLogoCN.svg");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalClickListener"] */ "/web/apps/smartproxy-global/src/components/integrations/globalClickListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalRouteChangeListener"] */ "/web/apps/smartproxy-global/src/components/integrations/globalRouteChangeListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PHProvider"] */ "/web/apps/smartproxy-global/src/components/integrations/posthog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingCookies"] */ "/web/apps/smartproxy-global/src/components/integrations/trackingCookies/TrackingCookies.ts");
;
import(/* webpackMode: "eager", webpackExports: ["LinkConfigProvider"] */ "/web/apps/smartproxy-global/src/components/LinkConfigProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactSales"] */ "/web/apps/smartproxy-global/src/decodo/features/ContactSales/ContactSales.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExperimentTracker"] */ "/web/apps/smartproxy-global/src/lib/experimentation/ExperimentTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationProvider"] */ "/web/apps/smartproxy-global/src/lib/i18n/i18n.client.tsx");
;
import(/* webpackMode: "eager" */ "/web/apps/smartproxy-global/src/styles/globals.css");
